<template>
  <ValidationProvider
    v-slot="{ errors }"
    :rules="calcRules"
    :name="title"
    slim
  >
    <FormGroup
      :title="title"
      :help="readonly || disabled ? '' : help"
      :error="errors[0]"
      :required="required && !readonly && !disabled"
      :horizontal="horizontal"
    >
      <input
        v-model="innerValue"
        :name="name"
        :placeholder="placeholder"
        :disabled="disabled"
        :readonly="readonly"
        :class="inputClass(errors[0])"
        :min="min"
        :max="max"
        type="number"
      >
    </FormGroup>
  </ValidationProvider>
</template>

<script>
import FormGroup from './FormGroup'
import { ValidationProvider } from 'vee-validate'

export default {
  components: {
    FormGroup,
    ValidationProvider,
  },
  props: {
    value: {
      type: [Number, String],
      default: null,
    },
    rules: {
      type: Object,
      default () {
        return {}
      },
    },
    title: {
      type: String,
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
    help: {
      type: String,
      default: '',
    },
    min: {
      type: Number,
      default: null,
    },
    max: {
      type: Number,
      default: null,
    },
    required: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    horizontal: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    innerValue: {
      get () { return this.value },
      set (n) {
        // empty string should be set to null (a string is not a number)
        n === '' ? this.$emit('input', null) : this.$emit('input', n)
      },
    },
    calcRules () {
      const r = Object.assign({ required: this.required, integer: true }, this.rules)
      if (this.min !== null && this.min !== undefined) {
        if (this.max !== null && this.max !== undefined) {
          r.between = { min: this.min, max: this.max }
        } else {
          r.min_value = this.min
        }
      } else if (this.max !== null && this.max !== undefined) {
        r.max_value = this.max
      }
      return r
    },
  },
  methods: {
    inputClass (invalid) {
      return {
        'form-control-plaintext': this.readonly,
        'form-control': !this.readonly,
        'is-invalid': invalid,
      }
    },
  },
}
</script>
